@font-face {
  font-family: "PT Serif";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url("/fonts/PTSerif-Regular.ttf") format("ttf");
}
@font-face {
  font-family: "PT Serif";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url("/fonts/PTSerif-Bold.ttf") format("ttf");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400 500 600 700;
  font-display: swap;
  src: url("/fonts/Inter-Regular.ttf") format("ttf");
}

html,
body,
#root,
#__next {
  height: var(--app-height, 100vh);
  min-height: -webkit-fill-available;
  width: 100%;
}

@supports (height: 100dvh) {
  html,
  body,
  #root,
  #__next {
    height: var(--app-height, 100dvh);
  }
}

:root {
  -webkit-text-size-adjust: 100%;
  color-scheme: light dark;
}
::selection {
  background-color: var(--selectionColor);
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--textSecondary);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--textPrimary);
}

::-webkit-scrollbar-thumb:active {
  background: var(--textPrimary);
}

* {
  scrollbar-width: thin;
  scrollbar-color: var(--textSecondary) transparent;
}

/* Expo Router Modal uses Vaul for modals, but does not expose this property more ergonomically */
[data-vaul-overlay] {
  backdrop-filter: blur(8px);
}

/* Prevent placeholder text from wrapping and causing scrollbars at high zoom levels */
textarea::placeholder {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/*
  This is a workaround for customer.io's in-app messages.
  since they are rendered in an inframe, the root selector
  applies color themeing that doesn't look appropriate in dark mode
  TODO: long term fix is to investigate theming for these messages with custom css
  within customer.io's in-app messages
*/
#gist-embed-message {
  color-scheme: light !important;
}
